import { Headphones } from 'lucide-react';
import React from 'react';

import { Button } from '@/components/ui/button';

interface MultipleRecordingsBannerProps {
  /** Number of recordings available */
  recordingCount: number;
  /** Callback when "View Recordings" is clicked */
  onViewRecordings: () => void;
}

/**
 * Banner component that shows when a case has multiple recordings available.
 * Displays an informational banner with headphone icon, message, and action button.
 */
export const MultipleRecordingsBanner: React.FC<MultipleRecordingsBannerProps> = ({
  recordingCount,
  onViewRecordings,
}) => {
  return (
    <div className="shrink-0 bg-gradient-to-r from-primary/10 to-primary/5 border-b border-primary/20 px-4 py-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Headphones className="w-5 h-5 text-primary" />
          <div>
            <h4 className="text-sm font-semibold text-primary">Multiple Recordings Available</h4>
            <p className="text-sm text-primary/80">This case has {recordingCount} recordings.</p>
          </div>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={onViewRecordings}
          className="border-primary/40"
        >
          View Recordings
        </Button>
      </div>
    </div>
  );
};
